module.exports = __webpack_public_path__ + "img/21.f34ec658.png";